import axios from "axios";
import React, { useState } from "react";
import { api } from "../utils/Api";
import { Typography, Flex, Button, notification, Row, Col } from "antd";
import Layout from "../layout/Layout";
import {
	CustomSearch,
	CustomSpinner,
	CustomTable,
} from "../utils/CustomComponents";
import dayjs from "dayjs";
import { SearchOutlined } from "@ant-design/icons";
import { CSVLink } from "react-csv";
import { useRef } from "react";

const { Text } = Typography;

const JobDownloadTaxType = () => {
	const [loading, setLoading] = useState(false);
	const [loadingTable, setLoadingTable] = useState(false);
	const [jobList, setJobList] = useState([]);
	const [startDate, setStartDate] = useState(dayjs());
	const [endDate, setEndDate] = useState(dayjs());
	const refDownload = useRef();
	const [apiNotification, contextHolder] = notification.useNotification();
	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "Job Number",
			dataIndex: "number",
			key: "number",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Date",
			dataIndex: "scheduledDate",
			key: "scheduledDate",
			render: (value) => {
				return <Text strong>{value}</Text>;
			},
		},
		// {
		// 	title: "Latitude",
		// 	dataIndex: "latitude",
		// 	key: "latitude",
		// 	render: (value) => {
		// 		return <Text>{value}</Text>;
		// 	},
		// },
		// {
		// 	title: "Longitude",
		// 	dataIndex: "longitude",
		// 	key: "longitude",
		// 	render: (value) => {
		// 		return <Text>{value}</Text>;
		// 	},
		// },
		{
			title: "Ship Address",
			dataIndex: "shipAddress",
			key: "shipAddress",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Customer Ship Address",
			dataIndex: "customerShipAddress",
			key: "customerShipAddress",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		// {
		// 	title: "Zip",
		// 	dataIndex: "zip",
		// 	key: "zip",
		// 	render: (value) => {
		// 		return <Text>{value}</Text>;
		// 	},
		// },
		{
			title: "Tax Type",
			dataIndex: "taxType",
			key: "taxType",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
	];

	const getJobList = async () => {
		try {
			setLoading(true);
			setLoadingTable(true);

			const start = `${startDate.year()}-${
				startDate.month() + 1
			}-${startDate.date()}`;
			const end = `${endDate.year()}-${endDate.month() + 1}-${endDate.date()}`;

			const url =
				api + `/job/get/taxtype/localities?startDate=${start}&endDate=${end}`;

			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.get(url);
			if (data.success) {
				let list = [];
				data.payload.map((item, index) => {
					list.push({
						key: index,
						id: item._id,
						number: item.jobId,
						// latitude: item.latitude,
						// longitude: item.longitude,
						shipAddress: item.shipAddress,
						customerShipAddress: item.customerShipAddress,
						taxType: item.type,
						// zip: item.zip,
						scheduledDate: dayjs(item.scheduledDate).format("MM/DD/YYYY"),
					});
				});
				setJobList(list);
			} else {
				openNotification("error", "Error", data.message);
			}
			setLoading(false);
			setLoadingTable(false);
		} catch (err) {
			console.error(err.message);
			openNotification("error", "Error", err.message);
			return null;
		}
	};

	const RenderTable = () => {
		return (
			<CustomTable columns={columns} data={jobList} loading={loadingTable} />
		);
	};

	const onRangeChange = (dates) => {
		if (dates) {
			setStartDate(dates[0]);
			setEndDate(dates[1]);
		}
	};

	const headers = () => {
		return columns.map((item) => {
			return {
				key: item.key,
				label: item.title,
			};
		});
	};

	const RenderDownloadReport = () => {
		return (
			<div>
				<CSVLink
					data={jobList}
					headers={headers()}
					filename={"57concrete-tax-type.csv"}
					hidden
					ref={refDownload}
				>
					Download report
				</CSVLink>
				<Row gutter={16}>
					<Col span={24}>
						<Button
							type="primary"
							style={{ width: "100%" }}
							onClick={(e) => refDownload.current.link.click()}
							loading={loading || loadingTable}
							disabled={loading || loadingTable}
							size="large"
						>
							Download Report
						</Button>
					</Col>
				</Row>
			</div>
		);
	};

	const RenderSearch = () => (
		<Flex gap={10} align="end" justify="space-between">
			<CustomSearch
				loading={loading}
				startDate={startDate}
				endDate={endDate}
				onRangeChange={onRangeChange}
				dateFormat={"MM/DD/YYYY"}
			/>
			<Button
				type="primary"
				onClick={() => getJobList()}
				icon={<SearchOutlined />}
				size="large"
				loading={loading}
			>
				Search
			</Button>
		</Flex>
	);

	return (
		<Layout title="Job Download Tax Type" description="Job Report">
			<Flex vertical gap={16}>
				<RenderSearch />
				<RenderDownloadReport />
				{loading ? <CustomSpinner /> : <RenderTable />}
				{contextHolder}
			</Flex>
		</Layout>
	);
};

export default JobDownloadTaxType;
